'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (typeof global !== 'object' || !global || global.Math !== Math || global.Array !== Array) {
		return implementation;
	}
	return global;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/globalthis/polyfill.js
 ** module id = 998
 ** module chunks = 0
 **/